import { PermissionEnum } from "@dashboard/graphql";
import { asSortParams } from "@dashboard/utils/sort";
import React from "react";
import { Route, RouteComponentProps, Switch } from "react-router-dom";

import { inquiryFormCreateUrl, inquiryFormsListUrl,inquiryFormUrl } from "./urls";
import InquiryFormsListComponent from "./views/InquiryFormsList";

const InquiryFormsListView: React.FC<RouteComponentProps<{}>> = ({ location }) => {
  const qs = new URLSearchParams(location.search);
  const paramsObj: Record<string, string> = {};

  qs.forEach((value, key) => {
    paramsObj[key] = value;
  });

  const params = asSortParams(paramsObj, {});

  return <InquiryFormsListComponent params={params} />;
};

interface InquiryFormsSection {
  permissions?: PermissionEnum[];
}

const InquiryFormsSection: React.FC<InquiryFormsSection> = () => {
  return (
    <Switch>
      <Route exact path={inquiryFormsListUrl()} component={InquiryFormsListView} />
      <Route path={inquiryFormCreateUrl()} render={() => <div>Create Inquiry Form</div>} />
      <Route path={inquiryFormUrl(":id")} render={() => <div>Inquiry Form Details</div>} />
    </Switch>
  );
};

export default InquiryFormsSection;